import $ from 'jquery';
import React from 'react';
import {connect} from "react-redux";
import {Dummy} from '../';
import styles from './style.css';
import {htmlParam} from "../../../lib/utils";


export class Economentry extends Dummy {
    onClick() {
        $('#expectations').toggle(500);
    }

    render() {
        return (
            <div className={styles.econom}>
                <div className="row">
                    <div className="col-md-4">
                        <table className={styles.tg}>
                            <tbody>
                            <tr>
                                <th className={styles.tgF6ar}> Текущая дата</th>
                                <th className={styles.tgCxkv}>{this.props.params['ti_8_126_101'].value}.{this.props.params['ti_8_126_102'].value}.{this.props.params['ti_8_126_103'].value}</th>
                            </tr>

                            <tr>
                                <th className={styles.tgF6ar}>Дата внедрения</th>
                                <th className={styles.tgCxkv}>{this.props.params['ti_8_126_104'].value}.{this.props.params['ti_8_126_105'].value}.{this.props.params['ti_8_126_106'].value}</th>
                            </tr>
                            </tbody>
                        </table>
                    </div>

                    <div className="col-md-4">
                        <table className={styles.tg}>
                            <tbody>
                            <tr>
                                <th className={styles.tgF6ar} colSpan="4">Действующий тариф:</th>
                            </tr>
                            <tr>
                                <th className={styles.tgF6ar}>Электроэнергия</th>
                                {htmlParam(this.props.params['ti_8_126_6'], 'th', styles.disabled, styles.tgT3d6)}
                            </tr>
                            <tr>
                                <th className={styles.tgF6ar}>Теплоэнергия</th>
                                {htmlParam(this.props.params['ti_8_126_10'], 'th', styles.disabled, styles.tgT3d6)}
                            </tr>
                            </tbody>
                        </table>
                    </div>

                </div>
                <h3>Экономические показатели:</h3>

                <table className={styles.tg}>
                    <tbody>
                    <tr>
                        <th className={styles.tgF6ar}/>
                        <th className={styles.tgF6ar}>Затраты Э/Э (кВт*ч)</th>
                        <th className={styles.tgF6ar}>Стоимость Э/Э (грн.)</th>
                        <th className={styles.tgF6ar}>Выработка Т/Э (Гкал)</th>
                        <th className={styles.tgF6ar}>Стоимость Т/Э * (грн)</th>
                        <th className={styles.tgF6ar}>Экономия (грн)</th>
                        <th className={styles.tgF6ar}>Себестоимость<br/> одной Гкал Т/Э</th>
                        <th className={[styles.tgF6ar, styles.kpd].join(' ')}> КПД</th>
                    </tr>
                    <tr>
                        <td className={styles.tgF6ar}>Сутки<br/> предыдущие</td>
                        {htmlParam(this.props.params['ti_8_126_11'], 'td', styles.disabled, styles.tgT3d6)}
                        {htmlParam(this.props.params['ti_8_126_20'], 'td', styles.disabled, styles.tgT3d6)}
                        {htmlParam(this.props.params['ti_8_126_12'], 'td', styles.disabled, styles.tgT3d6)}
                        {htmlParam(this.props.params['ti_8_126_21'], 'td', styles.disabled, styles.tgT3d6)}
                        {htmlParam(this.props.params['ti_8_126_22'], 'td', styles.disabled, styles.tgT3d6)}
                        {htmlParam(this.props.params['ti_8_126_23'], 'td', styles.disabled, styles.tgT3d6)}
                        {htmlParam(this.props.params['ti_8_126_13'], 'td', styles.disabled, styles.tgT3d6)}
                    </tr>
                    <tr>
                        <td className={styles.tgF6ar}>Декада<br/> (10 дней)</td>
                        {htmlParam(this.props.params['ti_8_126_24'], 'td', styles.disabled, styles.tgT3d6)}
                        {htmlParam(this.props.params['ti_8_126_26'], 'td', styles.disabled, styles.tgT3d6)}
                        {htmlParam(this.props.params['ti_8_126_25'], 'td', styles.disabled, styles.tgT3d6)}
                        {htmlParam(this.props.params['ti_8_126_27'], 'td', styles.disabled, styles.tgT3d6)}
                        {htmlParam(this.props.params['ti_8_126_28'], 'td', styles.disabled, styles.tgT3d6)}
                        {htmlParam(this.props.params['ti_8_126_29'], 'td', styles.disabled, styles.tgT3d6)}
                        {htmlParam(this.props.params['ti_8_126_30'], 'td', styles.disabled, styles.tgT3d6)}
                    </tr>
                    <tr>
                        <td className={styles.tgF6ar}>Сезон текущий</td>
                        {htmlParam(this.props.params['ti_8_126_41'], 'td', styles.disabled, styles.tgT3d6)}
                        {htmlParam(this.props.params['ti_8_126_43'], 'td', styles.disabled, styles.tgT3d6)}
                        {htmlParam(this.props.params['ti_8_126_42'], 'td', styles.disabled, styles.tgT3d6)}
                        {htmlParam(this.props.params['ti_8_126_44'], 'td', styles.disabled, styles.tgT3d6)}
                        {htmlParam(this.props.params['ti_8_126_45'], 'td', styles.disabled, styles.tgT3d6)}
                        {htmlParam(this.props.params['ti_8_126_46'], 'td', styles.disabled, styles.tgT3d6)}
                        {htmlParam(this.props.params['ti_8_126_47'], 'td', styles.disabled, styles.tgT3d6)}
                    </tr>
                    <tr>
                        <td className={styles.tgF6ar}>Сезон<br/> предыдущий</td>
                        {htmlParam(this.props.params['ti_8_126_48'], 'td', styles.disabled, styles.tgT3d6)}
                        {htmlParam(this.props.params['ti_8_126_50'], 'td', styles.disabled, styles.tgT3d6)}
                        {htmlParam(this.props.params['ti_8_126_49'], 'td', styles.disabled, styles.tgT3d6)}
                        {htmlParam(this.props.params['ti_8_126_51'], 'td', styles.disabled, styles.tgT3d6)}
                        {htmlParam(this.props.params['ti_8_126_52'], 'td', styles.disabled, styles.tgT3d6)}
                        {htmlParam(this.props.params['ti_8_126_53'], 'td', styles.disabled, styles.tgT3d6)}
                        {htmlParam(this.props.params['ti_8_126_54'], 'td', styles.disabled, styles.tgT3d6)}
                    </tr>
                    <tr>
                        <td className={styles.tgF6ar}>Весь период <br/>эксплуатации</td>
                        {htmlParam(this.props.params['ti_8_126_34'], 'td', styles.disabled, styles.tgT3d6)}
                        {htmlParam(this.props.params['ti_8_126_36'], 'td', styles.disabled, styles.tgT3d6)}
                        {htmlParam(this.props.params['ti_8_126_35'], 'td', styles.disabled, styles.tgT3d6)}
                        {htmlParam(this.props.params['ti_8_126_37'], 'td', styles.disabled, styles.tgT3d6)}
                        {htmlParam(this.props.params['ti_8_126_38'], 'td', styles.disabled, styles.tgT3d6)}
                        {htmlParam(this.props.params['ti_8_126_39'], 'td', styles.disabled, styles.tgT3d6)}
                        {htmlParam(this.props.params['ti_8_126_40'], 'td', styles.disabled, styles.tgT3d6)}
                    </tr>
                    </tbody>
                </table>
                <p>* по тарифам теплоэнергии </p>
            </div>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        params: state.params
    };
};

export default connect(mapStateToProps)(Economentry);


// WEBPACK FOOTER //
// ./src/components/entries/Economentry/index.js